import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Foso/filtrarExtracciones`, method: 'POST', body: values, token: token})
}
